module.exports = "<h1 style=\"color:rgb(49, 211, 16)\">\n  press works!\n</h1>"